import React, { useState, useContext, useEffect } from "react";
import { Form, ProgressBar } from "react-bootstrap"; // Import ProgressBar
import { ScoreContext } from "../../ScoreContext"; // Import ScoreContext
import { Row, Col, Card, Button,Spinner  } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import questionsData from "../../EUAIActCompliance.json";
import "bootstrap/dist/css/bootstrap.min.css";
import Menubar from "../../Menubar";
import NavigationBar from "../../Nav";
import BackgroundFooter from "../../BackgroundFooter";
import "../../../ComponentsCss/Iam.css";
import axios from "axios";
import { getGenAIExplanation } from "../../chatGPTService";

const EUAIActCompliance = ({ userData }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false;
  });
  const [activeSection, setActiveSection] = useState({});
  const { responses, fetchResponsesForSection, updateResponses, saveAllResponsesToBackend, updateScore, clearResponsesForSection, } = useContext(ScoreContext);
  // const [sectionResponses, setSectionResponses] = useState({}); // Initialize an empty object to hold responses for each section
  const [comments, setComments] = useState({}); // Store comments for each question
  const [loading, setLoading] = useState(false); // Loader for responses
  const [loadingComments, setLoadingComments] = useState(false); // Loader for comments
  
    const [showExplanationModal, setShowExplanationModal] = useState(false);
  const [explanationLoading, setExplanationLoading] = useState(false);
  const [explanationText, setExplanationText] = useState("");
  const [selectedQuestionText, setSelectedQuestionText] = useState("");
  const [explanationCache, setExplanationCache] = useState({});
  const [showSusanGenie, setShowSusanGenie] = useState(false);
const [susanGenieContent, setSusanGenieContent] = useState("");
const [susanGenieFiles, setSusanGenieFiles] = useState([]);
const [susanGenieUploading, setSusanGenieUploading] = useState(false);
const [isAddedToCommit, setIsAddedToCommit] = useState(false);

  // 🆕 NEW: Function to handle button click
  const handleAddToCommit = () => {
    setIsAddedToCommit(true);
  };
  
  
  const handleExplainWithGenAI = async (questionText, questionId) => {
    setSelectedQuestionText(questionText);
    setShowExplanationModal(true);
    setExplanationText("");
  
    // ✅ Check if we already have a cached explanation
    if (explanationCache[questionId]) {
      setExplanationText(explanationCache[questionId]);
      return;
    }
  
    setExplanationLoading(true);
  
    try {
      const response = await getGenAIExplanation(questionText);
      setExplanationText(response);
  
      // ✅ Cache it using questionId as key
      setExplanationCache((prev) => ({
        ...prev,
        [questionId]: response,
      }));
    } catch (error) {
      console.error("GenAI Error:", error);
      setExplanationText("Failed to get explanation. Please try again.");
    } finally {
      setExplanationLoading(false);
    }
  };
  
  const navigate = useNavigate();
  const section = "EUAIActCompliance";
  
    // 🔹 Function to Restrict Special Characters
    const sanitizeInput = (value) => {
      return value.replace(/[^a-zA-Z0-9\s]/g, ""); // Allow letters, numbers, and spaces only
    };;

  const disableRightClick = (e) => {
    e.preventDefault();
  };

  const getUserRegion = () => {
    return sessionStorage.getItem("userRegion") || "GB"; // Default to UK
  };
  const saveLastResponsePage = async (url) => {
    try {
      const userId = userData?.["cognito:username"];
      const payload = {
        userId,
        lastVisitedUrl: url, // Save the exact URL
        timestamp: new Date().toISOString(),
      };
      await axios.post("https://ddc0cx1ki1.execute-api.ap-southeast-2.amazonaws.com/prod", payload,
        {
          headers: {
           
            "Region": getUserRegion(), // Include user region dynamically
          },
        }
      
      );
    } catch (error) {
      console.error("Error saving last visited URL:", error);
    }
  };
  // Toggle Sidebar
  const handleSidebarToggle = () => {
    // Toggle the sidebar state
    setIsSidebarCollapsed((prevState) => !prevState);
  };

  useEffect(() => {
    // Save the updated state to localStorage
    localStorage.setItem("isSidebarCollapsed", JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  // Fetch responses when the component mounts or user changes
  useEffect(() => {
    if (userData && userData["cognito:username"]) {
      clearResponsesForSection(section); // Clear old responses when user changes
      fetchResponsesForSection(userData["cognito:username"], section);
    }
  }, [userData, fetchResponsesForSection, clearResponsesForSection,section]);


   // Add this useEffect after your existing ones
useEffect(() => {
  if (userData?.["cognito:username"]) {
    const savedData = localStorage.getItem(`susanGenie_${section}_${userData["cognito:username"]}`);
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setShowSusanGenie(parsedData.enabled || false);
        setSusanGenieContent(parsedData.content || "");
        setSusanGenieFiles(parsedData.files || []);
      } catch (error) {
        console.error("Error loading SUSAN Genie from localStorage:", error);
      }
    }
  }
}, [userData?.["cognito:username"]]);

// Add this useEffect to auto-save to localStorage
// Change this in PDPL component:
useEffect(() => {
  if (userData?.["cognito:username"]) {
    const susanGenieData = {
      enabled: showSusanGenie,
      content: susanGenieContent,
      files: susanGenieFiles,
      timestamp: new Date().toISOString()
    };
    
    localStorage.setItem(
      `susanGenie_${section}_${userData["cognito:username"]}`, 
      JSON.stringify(susanGenieData)
    );
  }
}, [showSusanGenie, susanGenieContent, susanGenieFiles, userData?.["cognito:username"]]);


// Add these functions after handleExplainWithGenAI
const handleSusanGenieFileUpload = async (files) => {
  setSusanGenieUploading(true);
  const fileArray = Array.from(files);
  const uploadedFileUrls = [];

  for (const file of fileArray) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("userId", userData["cognito:username"]);

    try {
      const res = await fetch(
        "https://gvnezn8m1a.execute-api.ap-southeast-2.amazonaws.com/prod",
        {
          method: "POST",
          headers: { Region: getUserRegion() },
          body: formData,
        }
      );

      if (res.ok) {
        const uploadedUrl = await res.text();
        uploadedFileUrls.push({ 
          name: file.name, 
          url: uploadedUrl,
          size: file.size,
          type: file.type
        });
      } else {
        console.error("Failed to upload:", file.name);
      }
    } catch (err) {
      console.error("Upload error:", err);
    }
  }

  setSusanGenieFiles(prev => [...prev, ...uploadedFileUrls]);
  setSusanGenieUploading(false);
};

const handleSusanGenieFileDelete = (fileName) => {
  setSusanGenieFiles(prev => prev.filter(file => file.name !== fileName));
};

const getSusanGenieDataForPayload = () => {
  if (!showSusanGenie) return null;
  
  return {
    enabled: showSusanGenie,
    content: susanGenieContent,
    files: susanGenieFiles,
    timestamp: new Date().toISOString()
  };
};

  // Comment submission function
  const handleCommentChange = (questionId, value) => {
    setComments((prevComments) => ({
      ...prevComments,
      [questionId]: value, // Update the specific question's comment
    }));
  };

  const postComment = async (questionId, section) => {
    const comment = comments[questionId]; // Get the comment for this specific question
    if (!comment || !comment.trim()) return; // Prevent empty comments
    
    const commentData = {
      userId: userData["cognito:username"],
      section,
      questionId,
      comment: comment, // Send the extracted string
    };
    setLoadingComments(true); // Show comment loader

    try {
      const response = await fetch("https://di8iz5adw3.execute-api.ap-southeast-2.amazonaws.com/prod", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Region": getUserRegion(),
        },
        body: JSON.stringify(commentData),
      });
      if (!response.ok) {
        throw new Error("Failed to post comment");
      }
   
      //setComments(""); // Clear the comment input after posting
    } catch (error) {
      console.error("Error posting comment:", error);
    } finally {
      setLoadingComments(false); // Hide comment loader
    }
  };


  
  
  
  const handleAnswerChange = (questionId, answer, question) => {
    const value = answer === "Yes" ? 1 : answer === "No" ? 0 : "NA";

    if (responses[section]?.[questionId]?.answer === value) return;
    setLoading(true); // Show loader
try{
   const susanGenieInfo = getSusanGenieDataForPayload();
    // Update responses in context
    updateResponses(section, questionId, {
      questionId,
      answer: value,
      questionText: question.question,
    });

    // Save the response to the backend (debounced)
    saveAllResponsesToBackend(userData["cognito:username"], section, susanGenieInfo);

    // Update the score in context
    updateScore(section, questionId, value, {
      question: question.question,
      moreInformation: question.moreInformation,
    });

    // Save the current URL
    saveLastResponsePage(window.location.pathname);

  } catch (error) {
    console.error("Error updating answer:", error);
  } finally {
    setLoading(false); // Hide loader
  }
};
  
    // Toggle content visibility
    const showContent = (questionId, section) => {
      setActiveSection((prevState) => ({
        ...prevState,
        [questionId]: prevState[questionId] === section ? null : section,
      }));
    };

 // Filter out "INFORMATIONAL" questions and get their IDs
const nonInformationalQuestions = questionsData["EUAIActCompliance"].filter(
  (question) => question.severity !== "INFORMATIONAL"
).map((question) => question.questionId);

// Total non-informational questions
const totalQuestions = nonInformationalQuestions.length;

// Count only answered non-informational questions
const answeredQuestions = Object.entries(responses[section] || {}).filter(
  ([questionId, response]) =>
    response.answer !== undefined && nonInformationalQuestions.includes(Number(questionId))
).length;

// Calculate progress
const progress = totalQuestions
  ? Math.round((answeredQuestions / totalQuestions) * 100)
  : 0;

  const totalIAMQuestions = questionsData["EUAIActCompliance"].filter(
    (q) => q.severity !== "INFORMATIONAL"
  ).length;

  const completedIAMQuestions = Object.entries(responses["EUAIActCompliance"] || {}).filter(
    ([questionId, response]) =>
      response.answer !== undefined
  ).length;


  const moduleProgress = {
    EUAIActCompliance: {
      completed: completedIAMQuestions,
      total: totalIAMQuestions,
    }
  }

   useEffect(() => {
    if (isAddedToCommit) {
      setIsAddedToCommit(false);
    }
  }, [responses, comments, showSusanGenie, susanGenieContent, susanGenieFiles]);
  return (
    <>
      <div  onContextMenu={disableRightClick}>
    

     {loading && (
        <div className="loading-overlay">
          <Spinner animation="border" variant="primary" />
        </div>
      )}



 <Row className="g-0">
  <Col
    xs={12}
    className={`bg-transparent sidebar-container ${isSidebarCollapsed ? "collapsed" : "hello"}`}
    style={{
      width: isSidebarCollapsed ? "90px" : "317px",
      transition: "width 0.3s ease",
    }}
  >
    <Menubar
      isCollapsed={isSidebarCollapsed}
      onToggle={handleSidebarToggle}
      moduleProgress={moduleProgress}
    />
  </Col>



  <Col
    className="pt-0 px-0  ps-0 section-container"
    style={{
      width: `calc(100% - ${isSidebarCollapsed ? "90px" : "317px"})`,
      transition: "width 0.3s ease",
    }}
  >
    <NavigationBar
      userData={userData}
      isSidebarCollapsed={isSidebarCollapsed}
    />

    <div className="sticky-top bg-white" style={{ top: "50px", zIndex: 999 }}>
      <div style={{ position: "relative" }}>
        <ProgressBar
          now={progress}
          className="custom-progress-bar"
          style={{ height: "20px", margin: "0px 10px 10px 10px" }}
        />
        <span
          style={{
            position: "absolute",
            top: "0",
            left: "50%",
            transform: "translateX(-50%)",
            color: "#000",
          }}
        >
          {`${progress}%`}
        </span>
      </div>
    </div>
    <Col className="overflow-auto p-4">

           <div class="d-flex justify-content-between">
          <h5>EU AI Act Compliance</h5>
          
        <button 
    type="button" 
    onClick={handleAddToCommit} 
    className={`btn ${isAddedToCommit ? 'btn-secondary' : 'btn-success'} navagateToDashboardButton`}
  >
    {isAddedToCommit ? "Added to next commit" : "Add to commit"}
  </button>
          </div>
          <Card className="mb-4" style={{ border: "1px solid #007bff" }}>
  <Card.Body>
    <div className="d-flex align-items-center justify-content-between mb-3">
      <h5 className="mb-0 fw-semibold text-primary">
        <i className="bi bi-robot me-2"></i>
        Genie Mode
      </h5>
      <Form.Check
        type="switch"
        id="susan-genie-switch-pdpl"
        label="Enable"
        checked={showSusanGenie}
        onChange={(e) => {
          const newValue = e.target.checked;
          setShowSusanGenie(newValue);
          
          if (!newValue) {
            setSusanGenieContent("");
            setSusanGenieFiles([]);
          }
        }}
      />
    </div>
    
    {showSusanGenie && (
      <>
        <Form.Group controlId="susanGenieContentPDPL" className="mb-3">
          <Form.Label>
            Please provide any additional information or specific requirements for this assessment:
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Enter any additional information, specific requirements, incidents, or context that may be relevant to this security assessment..."
            value={susanGenieContent}
            onChange={(e) => setSusanGenieContent(e.target.value)}
            className="susan-textarea"
          />
        </Form.Group>

        <Form.Group controlId="susanGenieFilesPDPL" className="mb-3">
          <Form.Label className="fw-semibold">
            Upload Supporting Documents:
          </Form.Label>
          <div className="d-flex align-items-center gap-2">
            <Form.Control
              type="file"
              multiple
              accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png"
              onChange={(e) => handleSusanGenieFileUpload(e.target.files)}
              disabled={susanGenieUploading}
              className="flex-grow-1"
            />
            {susanGenieUploading && (
              <Spinner animation="border" size="sm" variant="primary" />
            )}
          </div>
          <Form.Text className="text-muted">
            Accepted formats: PDF, DOC, DOCX, TXT, JPG, PNG (Max 10MB per file)
          </Form.Text>
        </Form.Group>

        {susanGenieFiles.length > 0 && (
          <div className="mb-3">
            <Form.Label className="fw-semibold">Uploaded Files:</Form.Label>
            <div className="bg-white p-2 border rounded">
              {susanGenieFiles.map((file, index) => (
                <div key={index} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-file-earmark me-2 text-primary"></i>
                    <div>
                      <small className="fw-semibold">{file.name}</small>
                      <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                        {(file.size / 1024 / 1024).toFixed(2)} MB
                      </div>
                    </div>
                  </div>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleSusanGenieFileDelete(file.name)}
                  >
                    <i className="bi bi-trash"></i>
                  </Button>
                </div>
              ))}
            </div>
          </div>
        )}
         <Form.Text className="text-muted">
          This information and files will be processed by SUSAN Genie and included in your security assessment report.
        </Form.Text>
      </>
    )}
  </Card.Body>
</Card>

          {questionsData["EUAIActCompliance"].map((question, index) => (
            <Card key={question.questionId} className="mb-4">
              <Card.Body>
                 {/* Green Tick Icon */}
                {responses[section]?.[question.questionId]?.answer !== undefined && (
                <span className="green-tick">&#10004;&#xFE0E;</span> // Unicode for ✓
                )}
                            <h5 className="no-select" draggable="false">
  <strong>{index + 1}.</strong>{" "}
  {question.question || "No description available"}
  <button
    className="btn btn-sm ms-2"
    title="Explain with GenAI"
    onClick={() => handleExplainWithGenAI(question.question, question.questionId)}
  >
    ℹ️
  </button>
</h5>
                <Row className="align-items-center">
                  {/* Radio buttons column */}
                  <Col md={6} xs={12} className="ms-3">
                  <div className="d-flex flex-column flex-md-row justify-content-start">
                    {question.severity === "INFORMATIONAL" ? (
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name={`q${question.questionId}`} // Unique name using index
                          value="informational"
                          disabled
                          onChange={() =>
                            handleAnswerChange(
                              index,
                              "Not Applicable",
                              question
                            )
                          }
                        />
                        <label className="form-check-label">
                          Informational
                        </label>
                     
                      </div>
                    ) : (
                      <>
                         <div className="form-check mb-2 mb-md-0 me-md-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`q${question.questionId}`} // Unique name using index
                            value="yes"
                            checked={Number(responses[section]?.[question.questionId]?.answer) === 1} // Check based on context
                            onChange={() =>{
                              
                              handleAnswerChange(question.questionId, "Yes", question)
                            }}
                          />
                          <label className="form-check-label">Yes</label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`q${question.questionId}`} // Unique name using index

                            value="no"
                            checked={Number(responses[section]?.[question.questionId]?.answer) === 0} // Check based on context
                            onChange={() =>{
                             
                              handleAnswerChange(question.questionId, "No", question)
                            }}
                          />
                          <label className="form-check-label">No</label>
                        </div>
                        
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`q${question.questionId}`} // Unique name using index
                            value="not-applicable"
                            checked={responses[section]?.[question.questionId]?.answer === "NA"}
                            onChange={() =>
                              handleAnswerChange(
                                question.questionId,
                                "Not Applicable",
                                question
                              )
                            }
                          />
                          <label className="form-check-label">
                            Not Applicable
                          </label>
                        </div>
                       
                      </>
                    )}
                    </div>
                  </Col>

                  {/* Vertical buttons column */}
                  <Col md={12} xs={12} className="d-flex flex-wrap align-items-start justify-content-start ms-3 mt-3" draggable="false">
                    <button 
                      variant="outline-primary"
                      className="buttonI"
                      onClick={() => showContent(question.questionId, "description")}
                    >
                      Description
                    </button>
                    <button
                      variant="outline-primary"
                      className="buttonI"
                      onClick={() => showContent(question.questionId, "benefits")}
                    >
                      Recommendations
                    </button>
                    <button
                      variant="outline-primary"
                      className="buttonI"
                      onClick={() => showContent(question.questionId, "comment")}
                    >
                      Comment
                    </button>
                    {/* {question.moreInformation && (
                      <a
                        className="btn btn-link"
                        href={question.moreInformation.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        More Information
                      </a>
                    )} */}
                  </Col>

                  {/* Content display column */}
                  <Col md={8} className="mt-3 ms-3">
                    <div>
                      {activeSection[question.questionId] === "description" && (
                        <div className="content no-select" draggable="false">
                          <h5>Description</h5>
                          <p>
                            {question.description ||
                              "No description available."}
                          </p>
                        </div>
                      )}
                      {activeSection[question.questionId] === "benefits" && (
                        <div className="content no-select" draggable="false">
                          <h5>Benefits & Recommendations</h5>
                          <p>
                            {question.recommendations || " "}
                          </p>
                          {question.moreInformation && question.moreInformation.link && (
                      <a
                        className="btn btn-link mt-2"
                        href={question.moreInformation.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Reference Guide
                      </a>
                    )}
                        </div>
                      )}
                      {activeSection[question.questionId] === "comment" && (
                        <div className="content">
                          <h5>Comment</h5>
                          <textarea
                            className="form-control mb-2"
                            placeholder="Add your comment here..."
                            value={comments[question.questionId] ?? ""} // Use nullish coalescing for fallback
                            onChange={(e) => handleCommentChange(question.questionId,sanitizeInput(e.target.value))}
                          ></textarea>
                          <div className="text-end">
                            <button
                              variant="success"
                              className="Postbtn"
                              onClick={() => postComment(question.questionId, "EUAIActCompliance")}
                            >
                              Post
                            </button>
                          </div>
                        </div>
                      )}
                      {loadingComments && activeSection[question.questionId] === "comment" && (
                      <Spinner animation="border" variant="primary" className="mt-3" />
                    )}
                    </div>
                  </Col>
                 
                </Row>
                <p className="srvql">srql.com</p>
              </Card.Body>
            </Card>
          ))}
          {/* <div className="d-flex justify-content-between mb-3 mt-4 NButton">
            <Button className="Pre" variant="secondary" onClick={() =>   navigate("/nationalcybersecuritybill")}>
            Ireland
            </Button>
            <Button className="Nxt" variant="primary" onClick={() => navigate("/govassureprogram")}>
            GovAssure Program
            </Button>
          </div> */}
           <div class="d-flex justify-content-end">
  <button 
    type="button" 
    onClick={handleAddToCommit} 
    className={`btn ${isAddedToCommit ? 'btn-secondary' : 'btn-success'} navagateToDashboardButton`}
  >
    {isAddedToCommit ? "Added to next commit" : "Add to commit"}
  </button>
</div>
           </Col>
             <BackgroundFooter isSidebarCollapsed={isSidebarCollapsed}  />
        </Col>
      </Row>
         {/* GenAI Explanation Modal */}
          {showExplanationModal && (
          <div className="genai-modal">
          <div className="genai-modal-content">
            <span className="genai-close" onClick={() => setShowExplanationModal(false)}>&times;</span>
            <h5>GenAI Explanation</h5>
            {explanationLoading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <p>{explanationText}</p>
            )}
          </div>
        </div>
      )}
     
      </div>
    </>
  );
};

export default EUAIActCompliance;
